import PocketBase from 'pocketbase';

const POCKETBASE_URL = import.meta.env.VITE_POCKETBASE_URL;

if (!POCKETBASE_URL) {
  console.warn('VITE_POCKETBASE_URL not set. API calls will fail.');
}

export const pb = new PocketBase(POCKETBASE_URL);

// Disable auto-cancellation for React Query compatibility
pb.autoCancellation(false);

/** Get current authenticated user ID (throws if not authenticated) */
export function getCurrentUserId(): string {
  const user = pb.authStore.model;
  if (!user) {
    throw new Error('Not authenticated');
  }
  return user.id;
}
